import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  storageTrialLimitOpen: true,
};
const limitBannerSlice = createSlice({
  name: 'limitBannerSlice',
  initialState,
  reducers: {
    setStorageTrialLimitOpen: (state, action) => {
      state.storageTrialLimitOpen = action.payload;
    },
  },
});

export const { setStorageTrialLimitOpen } = limitBannerSlice.actions;
export default limitBannerSlice.reducer;
